import { AnyAction } from 'redux';
import { isTokenUpdate } from './actions';
import { AuthState } from './state';

export const INITIAL_STATE: AuthState = {
  authenticated: false
};

export function auth(state = INITIAL_STATE, action: AnyAction): AuthState {
  if (isTokenUpdate(action)) {
    return {
      authenticated: true,
      getTokenFunction: action.getTokenFunction,
      logoutFunction: action.logoutFunction
    };
  }

  return state;
}
